import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';
import store from '@/store';
import CLoader from '@/components/shared/CLoader.vue';

interface BreadcrumbItem {
    name: string;
    href: string;
    link?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VueRouterWrapper',
  setup(__props) {

const route = useRoute();

const breadcrumbItems = computed(() => {
    const breadcrumbs: BreadcrumbItem[] = route.meta?.breadcrumb || [];
    return breadcrumbs.map((b) => ({
        to: b.link,
        text: b.name,
        href: b.href
    }));
});

const loader = computed(() => {
    const state = store.state.loader;
    return {
        value: state.active,
        text: state.text
    };
});

return { __sfc: true,route, breadcrumbItems, loader, CLoader }
}

})